import { render } from "./Footer.vue?vue&type=template&id=091cabb0"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=091cabb0&lang=css"
script.render = render

export default script